import React, { useState, useEffect } from 'react';
import axios from 'axios';

const LiveAdBreakButton = ({ livestreamId }) => {
  const [status, setStatus] = useState({ adBreakActive: false, remainingSeconds: 0 });
  const SSAI_URL = process.env.REACT_APP_SSAI_MICROSERVICE_URL || 'http://localhost:3003';
  const SSAI_KEY = process.env.REACT_APP_SSAI_API_KEY || 'ssai_secure_key_flick';

  useEffect(() => {
    if (!status.adBreakActive) return;
    const interval = setInterval(async () => {
      try {
        const res = await axios.get(
          `${SSAI_URL}/api/live/stream/${livestreamId}/status`
        );
        setStatus(res.data);
        if (!res.data.adBreakActive) clearInterval(interval);
      } catch (e) { clearInterval(interval); }
    }, 1000);
    return () => clearInterval(interval);
  }, [status.adBreakActive]);

  const triggerBreak = async () => {
    try {
      const res = await axios.post(
        `${SSAI_URL}/api/live/stream/${livestreamId}/cue-out`,
        { duration: 30 },
        { headers: { 'x-api-key': SSAI_KEY, 'Content-Type': 'application/json' } }
      );
      if (res.data.success) {
        setStatus({ adBreakActive: true, remainingSeconds: 30 });
      } else {
        alert(`Ad break failed: ${res.data.reason || 'No eligible campaign'}`);
      }
    } catch (e) {
      alert('Ad break trigger failed: ' + e.message);
    }
  };

  return (
    <button
      onClick={triggerBreak}
      disabled={status.adBreakActive}
      style={{
        background: status.adBreakActive ? '#555' : '#EF9F27',
        color: '#fff',
        border: 'none',
        borderRadius: 6,
        padding: '6px 16px',
        fontWeight: 600,
        fontSize: 13,
        cursor: status.adBreakActive ? 'not-allowed' : 'pointer'
      }}
    >
      {status.adBreakActive
        ? `Ad playing — ${status.remainingSeconds}s left`
        : 'Insert Ad Break'}
    </button>
  );
};

export default LiveAdBreakButton;
